module.exports = __webpack_public_path__ + "static/media/cardCover.d4c3328e.png";